import { useEffect } from 'react'
import { useDispatch } from 'react-redux'

import { PanelBox } from '../default'
import { CompanyCustomersTable } from '../tables'
import { acGetCompanyCustomers } from '../../store/actions'


/**
 * Displays the Company Customers Table.
 *
 * @author José Pedro Paludo
 * @returns {React.Component} The rendered CreateCreditPolicyPanel component.
 */
const CustomersPanel = () => {

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(acGetCompanyCustomers())
    }, [])

    return (
        <PanelBox title='Clientes'>
            <CompanyCustomersTable />
        </PanelBox>
    )
}

export default CustomersPanel
